// --- Fabric UI
import {
  Button,
  Menu,
  MenuItem,
  MenuList,
  MenuPopover,
  MenuTrigger,
  Persona,
  Text,
} from "@fluentui/react-components";
import { PersonFilled, SignOutRegular } from "@fluentui/react-icons";
import { Flex } from "components/styled";
import { useAppTheme } from "hooks/useAppTheme";
import { IUser } from "library/types";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

type Props = {
  userData: IUser | null;
  logout: () => void;
};

export function UserSettingsMenu({ userData, logout }: Props) {
  const { t } = useTranslation();
  const theme = useAppTheme();

  return (
    <Container>
      <Menu positioning={{ autoSize: true }} persistOnItemClick>
        <MenuTrigger disableButtonEnhancement>
          <Persona
            {...{
              text: userData?.displayName || "",
              imageUrl: userData?.photoSmall || "",
            }}
            avatar={
              userData && userData?.displayName && userData?.photoSmall
                ? {
                    image: {
                      src: userData?.photoSmall,
                    },
                  }
                : {
                    icon: <PersonFilled />,
                  }
            }
            name=""
            secondaryText=""
            size="large"
            style={{
              height: "100%",
              display: "flex",
              alignItems: "center",
            }}
          />
        </MenuTrigger>

        <MenuPopover
          style={{
            top: "10px !important",
            padding: 0,
          }}
        >
          <MenuList
            style={{
              padding: "10px 0",
              width: "fit-content",
            }}
          >
            <StyledMenuItem>
              <Flex direction="column" gap="20px" $align="flex-start">
                <Flex direction="column" $align="flex-start" gap="5px">
                  <Text weight="semibold" size={300}>
                    {userData?.displayName}
                  </Text>
                  <Text size={200}>
                    {userData?.mail || userData?.userPrincipalName}
                  </Text>
                </Flex>

                <Button
                  id="logout"
                  onClick={() => logout()}
                  appearance="transparent"
                  iconPosition="after"
                  style={{
                    width: "100%",
                    justifyContent: "flex-end",
                    paddingRight: "0px",
                    fontSize: "12px",
                    fontWeight: 400,
                    color: theme.palette.purpleDark,
                  }}
                  icon={<SignOutRegular />}
                >
                  {t("header.SignOut")}
                </Button>
              </Flex>
            </StyledMenuItem>
          </MenuList>
        </MenuPopover>
      </Menu>
    </Container>
  );
}

const Container = styled.div``;
const StyledMenuItem = styled(MenuItem)`
  padding: 7px 15px;
  &:hover {
  cursor: default;
    background-color: transparent;
`;
